
import React from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { resolveDocumentDirection } from "@/i18n/languages"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()
  const { i18n } = useTranslation()
  const direction = resolveDocumentDirection(i18n.resolvedLanguage || i18n.language)

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      dir={direction}
      className="toaster group"
      style={{ zIndex: 9999 }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

/** Root toaster: follows i18n dir so the close control sits on the logical end. */
export function DirectedToaster(props: ToasterProps) {
  const { i18n } = useTranslation()
  const direction = resolveDocumentDirection(i18n.resolvedLanguage || i18n.language)

  return <Sonner dir={direction} {...props} />
}

export { Toaster, toast }

